import dayjs from "dayjs";
const {appTimezone} = useRuntimeConfig().public

export function checkActiveTimeRange(from: string | null, to: string | null) {
    if (from && to) {
        return dayjs().tz(appTimezone).isAfter(dayjs(from)) && dayjs().tz(appTimezone).isBefore(dayjs(to))
    }
    return true
}